<template>
  <v-container class="max-width-1200">
    <v-row>
      <v-col class="pb-0 headline text-uppercase">
        {{ $t('common.studies') }}
      </v-col>
    </v-row>
    <v-row>
      <v-col class="display-1">
        {{ $t('common.learnAboutOurWork')}}
      </v-col>
    </v-row>

    <v-row class="text-center justify-center">
      <v-col
        v-for="(item,index) in studies"
        :key="index"
        cols="12" sm="6" md="4" lg="3">
        <v-hover
          v-slot="{ hover }">
          <v-card
            flat
            @click="openStudy(item)">
            <v-img
              height="300px"
              :src="item.img">
              <v-expand-transition>
                <div
                  v-if="hover"
                  class="d-flex transition-fast-in-fast-out primary darken-2 overlay-hover display-3 white--text"
                  style="height: 100%;">
                    {{ $t("common.readMore") }}
                </div>
              </v-expand-transition>
              <v-row class="white--text fill-height align-end overlay">
                <v-icon
                  v-if="actualStudy.id == item.id"
                  dark
                  class="icon-tile-mark">
                  mdi-bookmark
                </v-icon>
                <v-col cols="12" class="px-8 title text-start">
                  <!-- {{ item.title }} -->
                </v-col>
                <v-col v-if="!hover" cols="12" class="px-8 text-start">
                  <span class="title">{{ $t(item.title) }}</span><br>
                  <span class="overline">{{ $t("common.clickAndReadMore") }}</span>
                </v-col>
              </v-row>
            </v-img>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <v-row id="studyText" class="min-height-300">
      <v-expansion-panels
        v-model="panel"
        accordion
        flat>
        <v-expansion-panel
          v-for="(item,index) in studies"
          :key="index"
          class="d-none">
          <v-expansion-panel-content>
            <v-row>
              <v-col class="title">
                {{ $t(item.title) }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify">
                {{ $t(item.text) }}
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <v-row class="py-8 text-left justify-center">
      <v-col style="display:contents;">
        <div
          v-for="(item,index) in partners"
          :key="index"
          class="ma-4">
            <img
              :src="item.img"
              loading="lazy"
              :alt="item.title + 'kép'"
              height="30" :width="item.width"
              style="object-fit:contain;">
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Studies',
    extends: DataComponentBase,

    data: () => ({
      studies: [
        { id: "id1", index: 0, img: require("@/assets/img/em-energymonitor-studies-01.webp"),   title: 'energyMonitor.studies.title.01', text: "energyMonitor.studies.text.01" },
        { id: "id2", index: 1, img: require("@/assets/img/em-energymonitor-studies-02.webp"),   title: 'energyMonitor.studies.title.02', text: "energyMonitor.studies.text.02" },
        { id: "id3", index: 2, img: require("@/assets/img/em-energymonitor-studies-03.jpeg"),   title: 'energyMonitor.studies.title.03', text: "energyMonitor.studies.text.03" },
        { id: "id4", index: 3, img: require("@/assets/img/em-energymonitor-studies-04.webp"),   title: 'energyMonitor.studies.title.04', text: "energyMonitor.studies.text.04" },
      ],
      actualStudy: {
        id: "id1",
        title: "",
        text: "",
      },
      panel: 0,
      partners: [
        { img: require("@/assets/partners/partner_antennahungaria.png"),     name: "Antenna Hungária",                width: "86"  },
        { img: require("@/assets/partners/partner_elmu.png"),                name: "Elmű",                            width: "87"  },
        { img: require("@/assets/partners/partner_eon.png"),                 name: "EON",                             width: "103"  },
        { img: require("@/assets/partners/partner_00_flextronics.png"),      name: "Flextronics International Kft.",  width: "59"  },
        { img: require("@/assets/partners/partner_grafisoft.png"),           name: "Grafisoft",                       width: "90"  },
        { img: require("@/assets/partners/partner_magyartelekom.png"),       name: "Magyar Telekom",                  width: "128"  },
        { img: require("@/assets/partners/partner_vodafone.png"),            name: "Vodafone",                        width: "123"  },
        { img: require("@/assets/partners/partner_00_nassmagnet.png"),       name: "Nass Magnet",                     width: "86"  },
        // { img: require("@/assets/partners/partner_origostudios.png"),        name: "Origo"  },
      ],

    }),

    computed: {
    },

    methods: {
      openStudy(study) {
        this.actualStudy.id    = study.id;
        this.actualStudy.title = study.title;
        this.actualStudy.text  = study.text;
        let panel = study.index;
        this.showStudy(panel, 'studyText')
      },
      showStudy(panel, id) {
        this.panel = panel;
        this.scrollTOSection(id);
      },
      scrollTOSection(id) {
        var section = document.getElementById(id);
        section.scrollIntoView();
      },
    },
  }
</script>
